import { Button, Flex, Typography, Upload } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import styles from './file-upload.module.scss';
import type { IFileUploadProps } from './types';
import { getFileMetaLabel } from './utils';

export const FileUpload = (props: IFileUploadProps) => {
  const {
    beforeUpload = () => false,
    description,
    fileList = [],
    replaceButtonText,
    selectButtonText,
    title,
    ...uploadProps
  } = props;

  const selectedFile = fileList[0];

  return (
    <Upload
      {...uploadProps}
      className={styles.upload}
      fileList={fileList}
      beforeUpload={beforeUpload}
      showUploadList={false}>
      <Flex className={styles.control} align='center' gap={10}>
        <Flex className={styles.icon} align='center' justify='center'>
          <FileOutlined />
        </Flex>
        <Flex className={styles.details} vertical>
          <Typography.Text className={styles.fileName} ellipsis>
            {selectedFile?.name || title}
          </Typography.Text>
          <Typography.Text className={styles.description}>
            {selectedFile ? getFileMetaLabel(selectedFile) : description}
          </Typography.Text>
        </Flex>
        <Button className={styles.button}>{selectedFile ? replaceButtonText : selectButtonText}</Button>
      </Flex>
    </Upload>
  );
};
